export function transformLevelContent(data) {
  return data.map(level => {
    if(level.subjects) return level

    const items = level.contentItems || ["General"];

    const subjects = items.map((title, idx) => ({
      title, 
      videos: Array.isArray(level.videos?.[idx]?.list)
        ? level.videos[idx].list
        : [],
      docs: Array.isArray(level.docs?.[idx]?.list)
        ? level.docs[idx].list
        : [],
      utils: []
    }));
  
    return {
      ...level,
      title: Array.isArray(level.title) 
      ? level.title[0] 
      : typeof level.title ==="string"
        ? level.title
        : "untitled",
      subjects,
      flatUtils: Array.isArray(level.utils) ? level.utils : []
      };
    });
}


/* export function transformLevelContent(data) {
  return data.map(level => {
    if(level.subjects) return level

    const contentTitles = level.contentItems || ["General"];
    const videos = level.videos || [];
    const docs = level.docs || [];
    const utils = level.utils || [];

    // Distribute the same content under multiple subject headers
    const subjects = contentTitles.map(title => ({
      title,
      videos,
      docs,
      utils
    }));
  
    return {
      ...level,
      title: Array.isArray(level.title) ? level.title[0] : level.title,
      subjects
      };
    });
} */